import {
  borderRadius,
  Button,
  customScrollMinimal,
  Input,
  typographyV2,
} from '@toggle/design-system';
import styled from 'styled-components';

export const LinkInputRoot = styled.div`
  margin-top: 32px;
`;

export const StyledInput = styled(Input)`
  ${Input.Styles.InputWrapper} {
    padding-right: 4px;
    background-color: var(--background-default);
  }
`;

export const InputLabel = styled.span`
  ${typographyV2.bodySm};
  margin-bottom: 4px;
`;

export const StyledButton = styled(Button)`
  position: absolute;
  bottom: 8px;
  right: 12px;
  background-color: var(--surface-default);

  &:disabled {
    border: none;
    background-color: var(--surface-default);
  }
`;

export const InputWrapper = styled.div`
  position: relative;
`;

export const TextareaElement = styled(Input.Styles.InputElement)`
  padding: 8px 12px;
  border: 1px solid var(--border-default);
  width: 100%;
  ${borderRadius.r1};
  ${customScrollMinimal};
  ${typographyV2.bodyBase};
  max-height: 240px;
  resize: none;

  &:hover {
    border: 1px solid var(--border-hover);
  }

  &:focus {
    border: 1px solid var(--border-primary);
  }
`;
